import './App.css'
import Post from "./Post.js"
import CreateAccount from './CreateAccount.js'
import Login from "./Login.js"

import React, { useState, useEffect } from 'react'
import { db, auth } from './firebase.js';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import  Button  from '@material-ui/core/Button';
import { Input } from '@material-ui/core';
import ImageUpload from './ImageUpload';



// styles

    function getModalStyle() {
      const top = 50;
      const left = 50;

      return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
      };
    }

    const useStyles = makeStyles((theme) => ({
      paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
      },
    }));



function App() {

const classes = useStyles();
const [modalStyle] = React.useState(getModalStyle);

  //state

      // feed state
      const [posts, setPosts] = useState([])

      //modals
      const [open, setOpen] = useState(false)
      const [openSignin, setopenSignin] = useState(false)


      //sign-up state
        const [email, setEmail] = useState('')
        const [username, setUsername] = useState('')
        const [password, setPassword] = useState('')

      // user auth state
      const [user, setUser] = useState("null")



// hold auth in state
      useEffect( () => {
       const unsubscribe = auth.onAuthStateChanged((authUser) => {
        if (authUser) {
          setUser(authUser);

        } else {
          setUser(null);
        }
      })
      return () => {
        unsubscribe();
      }
    }, [user, username]);



//map over all posts
    useEffect( () => {
    db.collection("posts").orderBy("timestamp", 'desc').onSnapshot(snapshot => {
    setPosts(snapshot.docs.map(doc => (
        {
        id: doc.id,
        post: doc.data()
        })
      ));
    })
  },[]);

// sign-up function


    const signUp = (event) => {
    event.preventDefault();
      auth.createUserWithEmailAndPassword(email, password)
        .then ((authUser) => {
      return authUser.user.updateProfile({
        displayName: username,
        })
      })
     .catch((error) => alert(error.message));

     setOpen(false);
    }

// sign-in function

  const signIn = (event) => {
    event.preventDefault();
    auth.signInWithEmailAndPassword(email, password)
    .catch((error) => alert(error.message) ) 
    setopenSignin(false);
  }
          
  return (
    <div className="App">

  
    
      {/*Sign-Up */}

            <Modal 
              open={open}
              onClose={() => setOpen(false)}
              >
                <div style={modalStyle} className={classes.paper}>
                    <CreateAccount
                    username={username} 
                    setUsername={setUsername} 
                    email={email} 
                    setEmail={setEmail} 
                    password={password} 
                    setPassword={setPassword}
                    signUp={signUp}
                    />
                </div>
            </Modal>

      {/*Sign-In */}

              <Modal
                open={openSignin}
                onClose={() => setopenSignin(false)}
              >
                <div style={modalStyle} className={classes.paper}>

                  <Login email={email} 
                  setEmail={setEmail} 
                  password={password} 
                  setPassword={setPassword}
                  signIn={signIn} 
                  />

                </div>
              </Modal>
        <center><p>By River. Made In React.js For Portfolio Purposes.</p></center>
        <div className="app__header"> 
          <img 
          className="app__headerImage"
          src="https://www.instagram.com/static/images/web/mobile_nav_type_logo.png/735145cfe0a4.png"
          alt="cant"
          />

             {/* Conditianal Renduring For Sign-In, Sign-Up, Logout*/}
            <div >
             {user ? (
              <Button variant="contained"  onClick={() => auth.signOut()} >Logout</Button>
            ) : (
              <div className="app_loginContainer">
              <Button variant="contained"  onClick={() => setopenSignin(true)}>Sign In</Button>
              <Button variant="contained"  onClick={() => setOpen(true)} >Sign Up</Button>
              </div>
            )}
            </div>

        </div>


          {/* Map Over Posts*/}
        <div className="App__posts">
          {
            posts.map( ({id, post}) => 
                <Post  key={id} postId={id} user={user} username={post.username} caption={post.caption} imageURL={post.imageURL}/>
            )
          } 
        </div>
             
        {/*upload */  }
        
        {user?.displayName ? (
            <ImageUpload username={user.displayName}/>
        ):(
          <h3>Sign-in to Upload</h3>
        )}

    </div>
  );
}

export default App;
